(() => {
  if (window.RajGlobalProductCardsLoaded) return;
  window.RajGlobalProductCardsLoaded = true;

  const selectors = {
    form: '[data-raj-gpc-form]',
    button: '[data-raj-gpc-submit]',
    message: '[data-raj-gpc-message]'
  };

  const getRoutes = () => window.routes || {};

  const getCartDrawer = () => document.querySelector('cart-drawer');

  const setMessage = (form, message) => {
    const messageNode = form.querySelector(selectors.message);
    if (!messageNode) return;

    if (message) {
      messageNode.textContent = message;
      messageNode.hidden = false;
    } else {
      messageNode.textContent = '';
      messageNode.hidden = true;
    }
  };

  const openCartDrawer = (cartData, activeElement) => {
    const cartDrawer = getCartDrawer();

    if (cartDrawer && cartData && cartData.sections && typeof cartDrawer.renderContents === 'function') {
      if (typeof cartDrawer.setActiveElement === 'function' && activeElement) {
        cartDrawer.setActiveElement(activeElement);
      }

      cartDrawer.renderContents(cartData);
    } else if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open(activeElement || undefined);
    }

    document.dispatchEvent(new CustomEvent('raj:cart:open'));
    document.dispatchEvent(new CustomEvent('raj:cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  };

  const submitForm = async (form) => {
    if (!form || form.dataset.rajLoading === 'true') return;

    const routes = getRoutes();
    const cartAddUrl = routes.cart_add_url || form.getAttribute('action') || '/cart/add';
    const cartDrawer = getCartDrawer();
    const button = form.querySelector(selectors.button) || form.querySelector('[type="submit"]');
    const activeElement = button || document.activeElement;
    const originalText = button ? button.textContent.trim() : '';
    const addingText = form.dataset.addingText || 'Adding...';
    const addedText = form.dataset.addedText || 'Added';

    form.dataset.rajLoading = 'true';
    setMessage(form, '');

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.textContent = addingText;
    }

    try {
      const formData = new FormData(form);

      if (!formData.get('quantity')) {
        formData.append('quantity', '1');
      }

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
      }

      const response = await fetch(cartAddUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: formData
      });

      const data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Unable to add this product.');
      }

      if (button) {
        button.textContent = addedText;
      }

      openCartDrawer(data, activeElement);

      window.setTimeout(() => {
        if (button) button.textContent = originalText;
      }, 900);
    } catch (error) {
      setMessage(form, error.message || 'Unable to add this product.');

      if (button) {
        button.textContent = originalText;
      }
    } finally {
      window.setTimeout(() => {
        form.dataset.rajLoading = 'false';

        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }
      }, 350);
    }
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target && event.target.closest ? event.target.closest(selectors.form) : null;
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();

      submitForm(form);
    },
    true
  );
})();